

import React from "react";
import { Button } from "@/components/ui/button";
import { Volume2 } from "lucide-react";
import useSpeech from "@/hooks/useSpeech";

export default function SpeakerButton({
  text = "",
  title = "Listen",
}) {
  const { speak } = useSpeech();

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      title={title}
      onClick={() => speak(text)}
      disabled={!text.trim()}
    >
      <Volume2 className="h-5 w-5" />
    </Button>
  );
}